import { jsxs as b, jsx as f } from "react/jsx-runtime";
import { format as m } from "date-fns";
import _, { forwardRef as i, useMemo as w } from "react";
import { useMonthsRange as g, useYearsRange as u, LABEL_YEAR_FORMAT as D, YEAR_FORMAT as O, LABEL_MONTH_FORMAT as P, MONTH_FORMAT as Y } from "./index.es5862.js";
import C from "./index.es5863.js";
import { DATEPICKER_SELECT_MONTH_TESTID as H, DATEPICKER_SELECT_YEAR_TESTID as k } from "./index.es2485.js";
import { IncrementDecrementMonthButton as h } from "./index.es5864.js";
import { RangeDropdowns as v } from "./index.es5865.js";
const x = i(
  ({ dpValue: t, onChange: r, incrementOrDecrementMonth: E, minDate: n, maxDate: s, position: a, id: R }, I) => {
    const L = H + a + "-" + R, A = k + a + "-" + R, M = g(t, s, n), d = u(t, s, n), e = w(
      () => ({
        month: m(t, Y),
        monthLabel: m(t, P),
        year: m(t, O),
        yearLabel: m(t, D)
      }),
      [t]
    ), y = _.useCallback(
      (c) => {
        const o = c.find((T) => T.isSelected), l = /* @__PURE__ */ new Date(`${o == null ? void 0 : o.value}-${e.month}-02`);
        r(l);
      },
      [r, e.month]
    ), S = _.useCallback(
      (c) => {
        const o = c.find((T) => T.isSelected), l = /* @__PURE__ */ new Date(`${e.year}-${o == null ? void 0 : o.value}-02`);
        r(l);
      },
      [r, e.year]
    );
    return /* @__PURE__ */ b("div", { className: C.rangelPanelHeader, ref: I, children: [
      a === "left" && /* @__PURE__ */ f(
        h,
        {
          isIncrement: !1,
          value: e,
          incrementOrDecrementMonth: E,
          minDate: n,
          maxDate: s
        }
      ),
      /* @__PURE__ */ f(
        v,
        {
          onMonthChange: S,
          onYearsChange: y,
          monthLabel: e.monthLabel,
          yearsLabel: e.yearLabel,
          monthsItems: M,
          yearsItems: d,
          yearsDropdownTestId: A,
          monthDropdownTestId: L
        }
      ),
      a === "right" && /* @__PURE__ */ f(
        h,
        {
          isIncrement: !0,
          value: e,
          incrementOrDecrementMonth: E,
          minDate: n,
          maxDate: s
        }
      )
    ] });
  }
);
export {
  x as DatePanelHeader
};
//# sourceMappingURL=index.es5861.js.map
